import React, { useEffect } from 'react';
import { Formik } from 'formik';
import FormInput from '../../../general/form-input/form-input.component';
import Button from '../../../general/button/button.component';
import './educationalandprofile.student.styles.scss';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import Padding from './../../../general/padding/Padding';
import { useNavigate } from 'react-router-dom';
import { doc, setDoc } from "firebase/firestore"; 
import { globalUSN } from "../../general/sign-up/sign-up.component"
import db from '../../../../firebase.config';
import ProgressIndicator from '../../general/progress-indicator/progress-indicator.component';
import { Backdrop, CircularProgress } from '@mui/material';

const EducationalProfileDetails = () => {

  let navigate = useNavigate();
  useEffect(() => {
    console.log(globalUSN);
    if(!globalUSN)
      navigate('../../../sessionexpired')
  })

  return (
  <div>
    <Formik
      initialValues={{ tenthper: '', twelfthper: '', UGCGPA: '', PGCGPA: '', linkedin: '', glassdoor: ''}}
      validate={values => {
        const errors = {};
        if (!values.tenthper) {
          errors.tenthper = 'Required';
        }
        if (!values.twelfthper) {
          errors.twelfthper = 'Required';
        }
        if (!values.UGCGPA) {
          errors.UGCGPA = 'Required';
        }
        if (!values.linkedin) {
          errors.linkedin = 'Required';
        }
        if (!values.glassdoor) {
          errors.glassdoor = 'Required';
        }
        return errors;
      }}
      onSubmit={(values, { setSubmitting }) => {
  
  const data = JSON.parse(JSON.stringify(values, null, 2));
  console.log(data);
  try {
  const studentRef = doc(db, 'studentData', globalUSN);
  console.log(studentRef);
  setDoc(studentRef, data , { merge: true });
  }
  catch (err)
  {
    console.log(err);
  }
  setSubmitting(true);
  setTimeout(() => {navigate(`../four`);},3000)

}}
    >
      {({
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
        isSubmitting
      }) => (
        
        <form onSubmit={handleSubmit}> 
        <ProgressIndicator />
        <span className="personal-details" style={{marginBottom:'3%'}}>
        <Typography variant="h4" sx={{fontFamily:'Montserrat'}}>Educational and Profile details</Typography>
          <FormInput  
            placeholder="10th %"
            type="number"
            name="tenthper"
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.tenthper}
          />
          <span style={{fontFamily : 'Montserrat'}}>{touched.tenthper && errors.tenthper}</span>
          <FormInput 
            placeholder="12th %"
            type="number"
            name="twelfthper"
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.twelfthper}
          />
           <span style={{fontFamily : 'Montserrat'}}>{touched.twelfthper && errors.twelfthper}</span>
           <FormInput 
            placeholder="UG CGPA"
            type="number"
            name="UGCGPA"
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.UGCGPA}
          />
          <span style={{fontFamily : 'Montserrat'}}>{touched.UGCGPA && errors.UGCGPA}</span>
          </span>
          
          <span className="personal-details" style={{marginBottom:'1px'}}>
          <Padding/>
          <Padding/>
          <Padding/>
          <Padding/>
          <FormInput 
            placeholder="PG CGPA (if applicable)"
            type="number"
            name="PGCGPA"
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.PGCGPA}
          />
          <FormInput 
            placeholder="LinkedIn Profile Link"
            type="text"
            name="linkedin"
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.linkedin}
          />
          <span style={{fontFamily : 'Montserrat'}}>{touched.linkedin && errors.linkedin}</span>
          <FormInput 
            placeholder="Glassdoor Profile Link"
            type="text"
            name="glassdoor"
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.glassdoor}
          />
          <span style={{fontFamily : 'Montserrat'}}>{touched.glassdoor && errors.glassdoor}</span>
          </span>
          <span className="personal-details">
          <Button type="submit" disabled={isSubmitting}>
            Next
          </Button>
          <Backdrop
          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={isSubmitting}
          >
          <CircularProgress color="inherit" />
          </Backdrop>
          </span>
        </form>
      )}
    </Formik>
  </div>
  );
}

export default EducationalProfileDetails;

